import React from 'react';
import { Card, Flex, Typography } from 'antd';
import { styled } from 'styled-components';
import { ArrowRightOutlined, RocketTwoTone } from '@ant-design/icons';
import { t } from '../../../../utils/i18n';

const StyledUpgradeCard = styled(Card)`
  margin: 2rem;
  min-width: 20rem;
  cursor: pointer;
  background-color: #f5f5f5;
  transition: background-color 0.4s ease;

  &:hover {
    background-color: #ebebeb;
  }

  .ant-v5-card-body {
    padding: 1.5rem;
  }
`;

const StyledRocketIcon = styled(RocketTwoTone)`
  font-size: 2.5rem;
  transform: rotate(45deg);
`;

const StyledRightIcon = styled(ArrowRightOutlined)`
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 0.45) !important;
`;

type UpgradeCardProps = { onCardClick: () => void };

export function SubscriptionUpgradeCard({ onCardClick }: UpgradeCardProps) {
  return (
    <StyledUpgradeCard onClick={onCardClick}>
      <Flex gap={10} align="center" justify="flex-start">
        <StyledRocketIcon twoToneColor="#00d0be" />
        <Typography.Text strong style={{ fontSize: 16 }}>
          {t('side-menu-cards.subscription-upgrade.title')}
        </Typography.Text>
      </Flex>
      <Flex align="flex-end" style={{ marginTop: 8 }}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {t('side-menu-cards.subscription-upgrade.description')}
        </Typography.Text>
        <StyledRightIcon />
      </Flex>
    </StyledUpgradeCard>
  );
}
